<section class="section" data-section-id="kontakt">
    <div class="container">
        <h2 class="heading section__heading">Kontakt</h2>

        <p class="paragraph">
            Kancelaria Notarialna jest czynna od poniedziałku do piątku w godzinach od 9:00 do 17:00.
        </p>

        <p class="paragraph">
            Istnieje możliwość indywidualnego umówienia terminu dokonania czynności poza wyznaczonymi 
            godzinami pracy Kancelarii oraz w soboty, po wcześniejszym uzgodnieniu. 
            Jeżeli przemawia za tym charakter czynności lub inne szczególne okoliczności 
            (w szczególności stan zdrowia stron) istnieje możliwość dokonania czynności notarialnej 
            poza siedzibą Kancelarii.
        </p>

        <address class="contact-tiles">
            <p class="paragraph contact-tile contact-tile--address">
                ul. Krakowska nr 180 lok. A3 <br />
                52-015 Wrocław <br />
                Budynek A kompleksu Dawna Pralnia
            </p>

            <div class="paragraph contact-tile contact-tile--people">
                <p class="m-0">
                    Notariusz Iwona Wrześniak <br />
                    <a href="tel:+48732775007" class="link" title="Telefon do Notariusz Iwona Wrześniak">
                        +48 732 775 007
                    </a>
                </p>
        
                <p class="m-0">
                    Notariusz Agnieszka Wencel
                    <br />
                    <a href="tel:+48732778007" class="link" title="Telefon do Notariusz Agnieszka Wencel">
                        +48 732 778 007
                    </a>
                </p>
            </div>

            <p class="paragraph contact-tile contact-tile--office">
                <a href="tel:+48713070089" class="link" title="Telefon do kancelarii">
                    +48 71 30 700 89
                </a>
                <br />
                <a href="mailto:kancelaria@ww-notariusz.pl" class="link" title="Adres email do kancelarii">
                    kancelaria@ww-notariusz.pl
                </a>
                <br />
                Pn-Pt: 09:00-17:00
            </p>

            <p class="paragraph contact-tile contact-tile--business">
                NIP: 8992963822
                <br />
                REGON: 525621158
            </p>
        </address>
    </div>
</section>

<iframe 
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5013.039360362358!2d17.077377701050754!3d51.080416136877176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc3ed4ee521e9%3A0x83b493189c29a183!2sKancelaria%20Notarialna%20Agnieszka%20Wencel%20Iwona%20Wrze%C5%9Bniak%20Sp%C3%B3%C5%82ka%20Cywilna!5e0!3m2!1sen!2spl!4v1732789077287!5m2!1sen!2spl" 
    allowfullscreen={false} 
    class="map"
    loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"
    title="Mapa wskazująca położenie kancelarii notarialnej"
></iframe>

<style>
    .contact-tiles {
        display: flex;
        flex-direction: column;
        gap: 3rem;
        margin: 3rem 0 0 0;
    }

    .contact-tile {
        display: block;
        font-size: 1.2rem;
        margin: 0;
        padding: 0 0 0 70px;
    }

    .contact-tile--address {
        background: url('/contact/address.svg') no-repeat center left;
    }

    .contact-tile--people {
        background: url('/contact/people.svg') no-repeat center left;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .contact-tile--office {
        background: url('/contact/office.svg') no-repeat center left;
    }

    .contact-tile--business {
        background: url('/contact/business.svg') no-repeat center left;
    }

    .map {
        width: 100%;
        height: 500px;
        border: none;
        margin: 0 0 -10px 0;
    }

    @media (min-width: 768px) {
        .contact-tiles {
            display: grid;
            grid-template-columns: auto auto; /* Two columns with auto width */
            grid-template-rows: auto auto;    /* Two rows with auto height */
            gap: 2rem; /* Optional: Add spacing between grid items */
            justify-content: center; /* Center grid horizontally */
            align-content: center;   /* Center grid vertically */
        }

        .contact-tile {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .contact-tile--office {
            display: block;
        }
    }
</style>